export enum SettlementRuleFormField {
    Name = 'name',
    PaymentPolicyKey = 'key',
    Trigger = 'trigger',
    Offset = 'offset',
    Value = 'value',
    Action = 'action',
    Type = 'type',
    OffsetType = 'offsetType',
}

export enum SettlementRuleOffsetType {
    Before = 'Before',
    After = 'After',
}

export interface WithPaymentPolicyId {
    paymentPolicyId: string;
}
